import React, { Component } from "react";

const HNode = (props) => {

  let html = []

  if(props.children.length) {
    html.push(<span> + </span>)
  }

  html.push(<span className="icon">{props.icon}</span>)
  html.push(<span className="name">{props.name}</span>)

  return (
    <div className="hierarchy-node">

      {html}

    </div>
  )
}

const defaultIcon = (type) => {
  switch (type) {
    case "text":
      return <span>T</span>
    default:
      return <span>E</span>
  }
}

export default class Hierarchy extends Component {

  document = null
  state = {
    nodes: []
  }

  setDocument(doc) {
    this.document = doc
    this.document.onUpdate(data => this.update())
  }

  update() {

    let nodes = []

    let els = this.document.getElementsAsArray()
    for(let e of els) {
      console.log("Childs of " + e.tag + " " + e.props.parentId);
      let childsArray = []
      React.Children.forEach(e.props.children, (childs) => {
        React.Children.forEach(childs.props.children, (child) => {
          let isChild = child.props && child.props.parentId !== undefined;
          if(isChild) childsArray.push(child);
        })
      })
      let id = e.get("id");
      let name = "";
      if (id) name = id.value;
      else name = e.tag;
      nodes.push(<HNode name={name} icon={defaultIcon(e.type)} children={childsArray}/>)
    }

    this.setState({
      nodes
    })
  }

  getHierarchy() {
    return (
      <div className="hierarchy">
        {this.state.nodes}
      </div>
    )
  }

  render() {
    return (
      <div className="hierarchy uipanel">
        <span className="title">
          Hierarchy
        </span>
        <span className="content">
          {this.getHierarchy()}
        </span>
      </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/hierarchy/Hierarchy.js